import React, { useEffect, useState, useContext } from "react";
import BookingReq from "../../../Utility/Requester/BookingReq";
import DateTime from "../../../Utility/Method/DateTime";
import moment from "moment-jalaali";
import Col from "../../../UIcomponent/Column";
import AvailabiltySchedule from "../../../Component/AvailabiltySchedule/AvailabiltySchedule";
import { Loader } from "../../../UIcomponent/Loader";
import Modal from "../../../UIcomponent/Modal";
import { TodayObj } from "../../../Utility/TodayObj";
import StyledButton from "../../../UIcomponent/Button";
const WeeklyModal = (props) => {
  const {
    ID,
    lang,
    loading,
    setLoading,
    available,
    visible,
    setShowWeeklyModal,
    onConfirm,
    disable,
  } = props;
  const [data, setData] = useState([]);
  // [{ "from": "2020-03-03T10:00:00+03:30", "to": "2020-03-03T13:00:00+03:30" }, { "from": "2020-03-04T10:00:00+03:30", "to": "2020-03-04T13:00:00+03:30" }, { "from": "2020-03-05T10:00:00+03:30", "to": "2020-03-05T13:00:00+03:30" }, { "from": "2020-03-07T23:30:00+03:30", "to": "2020-03-08T00:00:00+03:30" }, { "from": "2020-03-07T03:00:00+03:30", "to": "2020-03-07T23:30:00+03:30" }, { "from": "2020-03-08T08:00:00+03:30", "to": "2020-03-08T11:30:00+03:30" }]
  // )
  const CancelWeeklyModal = () => {
    setShowWeeklyModal(false);
  };
  const WeekDateTimeObj = (firstDay, mode) => {
    if (mode == "next") {
      return {
        dateTimeFrom: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
        ).toISOString(),
        dateTimeTo: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)
        ).toISOString(),
      };
    } else if (mode == "previous") {
      return {
        dateTimeFrom: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
        ).toISOString(),
        dateTimeTo: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)
        ).toISOString(),
      };
    } else {
      return null;
    }
  };

  const GetAvailabilty = (firstDay, mode, callBack) => {
    let params = {
      timeZone: DateTime.timeZone(),
      dateTimeFrom: WeekDateTimeObj(firstDay, mode).dateTimeFrom,
      dateTimeTo: WeekDateTimeObj(firstDay, mode).dateTimeTo,
    };
    // if (callBack) {
    //     callBack()
    // }
    // setLoading(true)

    BookingReq.getAvailability(ID, params)
      .then((res) => {
        let Result = [];
        if (res.data !== null) {
          Result = res.data.map((each) => {
            return {
              status: 1,
              date_time_from: each.from,
              date_time_to: each.to,
            };
          });
        }
        setData([...Result]);
        setLoading(false);
      })
      .catch((err) => {});
  };
  const onNextWeek = (firstDay) => {
    GetAvailabilty(firstDay, "next");
  };
  const onPreviousWeek = (firstDay) => {
    GetAvailabilty(firstDay, "previous");
  };
  useEffect(() => {
    GetAvailabilty(TodayObj(0), "next");
  }, [ID]);
  return (
    <Modal visible={visible} onCancel={CancelWeeklyModal}>
      <Col className="c__Teacher__Modal__Weekly">
        <AvailabiltySchedule
          duration={0.5}
          lang={lang}
          row={8}
          size={30}
          // noSelect
          mini
          Data={data}
          SessionCount={1}
          Slot={1}
          onNextWeek={onNextWeek}
          onPreviousWeek={onPreviousWeek}
          ID={ID}
          loading={loading}
          Loader={Loader}
          breakPoints={{
            xl: 22,
            lg: 22,
            md: 22,
          }}
          {...props}
        />
        {/* : <Loader
                    height={120}
                />} */}
        <StyledButton onClick={onConfirm} primary disable={disable}>
          رزرو کلاس
        </StyledButton>
      </Col>
    </Modal>
  );
};

export default WeeklyModal;
